import { Lock } from '@mui/icons-material';
import { Alert } from '@mui/material';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import messages from '../intl/messages';

// Shared "403 - not assigned" message for video and photo media (VideoBox, Identification)
const MediaAccessDeniedAlert = () => (
	<Alert severity="warning" icon={<Lock fontSize="inherit" />}>
		<FormattedMessage {...messages.mediaAccessDenied} />
	</Alert>
);

export default MediaAccessDeniedAlert;
